{
  "rating-star-icon": {
    "text": {
      "review": "review",
      "reviews": "reviews"
    }
  }
}
